export default {"src":"/_next/static/media/plan9.03e0c3cd.svg","height":27,"width":100};